export var OperationType;
(function (OperationType) {
    OperationType[OperationType["CREATE"] = 1] = "CREATE";
    OperationType[OperationType["MODIFY"] = 2] = "MODIFY";
    OperationType[OperationType["DELETE"] = 3] = "DELETE";
})(OperationType || (OperationType = {}));
//# sourceMappingURL=OperationType.js.map